import axios from "axios"
import { env } from "@web/lib/env"

export const contactsApi = axios.create({
  baseURL: env.VITE_CONTACTS_API_URL,
})